import { type AuthenticateRequest } from "@deskpro-product/messenger-api-schemas/messenger/api/conversation/mutation";
import type { DeviceType } from "@deskpro-product/messenger-api-schemas/messenger/database/models";

interface VerifyAuthParams {
  hostUserJwtToken: string | null;
  messengerId: string;
  tenantId: string;
  messengerToken: string;
  device: {
    id: string;
    type: DeviceType;
  };
}

export async function verifyAuth({
  hostUserJwtToken,
  messengerId,
  tenantId,
  messengerToken,
  device,
}: VerifyAuthParams): Promise<Response> {
  const origin = import.meta.env.VITE_MESSENGER_API_ORIGIN ?? window.location.origin;
  const path = import.meta.env.VITE_MESSENGER_API_PATH ?? "";
  return await fetch(`${origin}${path}/${tenantId}/messenger/${messengerId}/user/auth/verify`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Deskpro-Token": messengerToken,
    },
    body: JSON.stringify({
      device_id: device.id,
      device_type: device.type,
      token: hostUserJwtToken || undefined,
    } satisfies AuthenticateRequest),
  });
}
